import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "mysession-config",
    templateUrl: "./mysession-config.view.html",
    providers: []
})
export class MysessionConfigView implements OnInit {
    baseUrl = "";
    expansionStyle = "";
    headerConfig: any = {};
    drawerControlConfig: any = {};
    tabConfig: any = {};
    buttonConfig: any = {};
    iconList = [
        {
            label: "Cart",
            class: "fa-cart-arrow-down"
        },
        {
            label: "Cube",
            class: "fa-cube"
        }
    ];
    borderStyles: any = [
        {
            label: "Thick Color Underline",
            code: "solid"
        },
        {
            label: "Dashed Color Underline",
            code: "dashed"
        },
        {
            label: "Dotted Color Underline",
            code: "dotted"
        }
    ];

    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = sharedService.sessionUrl;
            this.headerConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].header;
            this.drawerControlConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].drawer_button;
            this.tabConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].tabConfig;
            this.buttonConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].button;
            this.expansionStyle = this.sharedService.expansionStyle;
        }
    }

    ngOnInit() {}
}
